module.exports = __webpack_public_path__ + "img/ddwu_gallery8.03be32b2.jpg";